import { render, staticRenderFns } from "./HeaderUtilityMenuItem.vue?vue&type=template&id=558c9015&"
import script from "./HeaderUtilityMenuItem.vue?vue&type=script&lang=js&"
export * from "./HeaderUtilityMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports